
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import type { ExplainMessages } from '../../../models/i18n/explain.messages'
import { defineComponent, ref } from 'vue'
import ExplainKpiMetrics from '../../../components/explain/explain-kpi-metrics.component.vue'
import ProductScoreOverview from '../../../components/explain/explain-products-analysis/product-score-overview.component.vue'
import { useExplainProductAnalysisAction } from '../../../composables/explain/use-explain-product-analysis-action'
import { useSearchResults } from '../../../composables/use-search-results'
import { ExplainUtils } from '../../../utils/explain.utils'
import { EpbAlert, EpbButton, EpbLoading, EpbPill, EpbText, SearchBox } from '../../shared'

export default defineComponent({
  name: 'CompareMode',
  components: {
    EpbText,
    EpbButton,
    SearchBox,
    ProductScoreOverview,
    ExplainKpiMetrics,
    EpbPill,
    EpbAlert,
    EpbLoading,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    messages: {
      type: Object as PropType<ExplainMessages>,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const compareQuery = ref()
    const result = ref<Result | undefined>(undefined)
    const totalScore = ref()

    const { tagExplainProductAnalysis } = useExplainProductAnalysisAction()
    const { getProductFromQuery, loading } = useSearchResults(props.productId)

    async function updateQuery(value: string): Promise<void> {
      compareQuery.value = value
      if (compareQuery.value) {
        tagCompareSearch()
        result.value = await getProductFromQuery(compareQuery.value)
        if (result.value) {
          totalScore.value = ExplainUtils.getResultScoreCriteria(result.value as Result).value
        }
      }
    }

    function tagCompareSearch(): void {
      tagExplainProductAnalysis()
    }

    return {
      baseClass: 'epb-compare-mode',
      compareQuery,
      loading,
      result,
      updateQuery,
      totalScore,
    }
  },
})
